/* eslint-disable eqeqeq */
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop, Pages } from '../../../../utils/Utils';
import BaseDesktopDialog from '../../../../custom_views/BaseDesktopDialog';
import ProIcon from '../../../ads_desk/AdsBoard/custom_views/ProIcon';



function NeedProDialog(props) {
    const isDesktop = getIsDesktop()
   
    const activate = () => {
        window.open(Pages.pro, '_blank')
        props.setShow(false)
    }
   
    const crown_bagde = () => {
        return(
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5265 10L13.2141 7.58486L13.2566 7.58643C13.4824 7.58643 13.6896 7.53075 13.8783 7.41941C14.067 7.30806 14.2178 7.15871 14.3307 6.97137C14.4436 6.78402 14.5 6.57547 14.5 6.34571C14.5 6.11948 14.4444 5.91269 14.3333 5.72534C14.2222 5.538 14.0723 5.38865 13.8836 5.27731C13.6949 5.16596 13.4859 5.11029 13.2566 5.11029C13.0309 5.11029 12.8254 5.16596 12.6402 5.27731C12.455 5.38865 12.3069 5.53888 12.1958 5.728C12.0847 5.91711 12.0291 6.12301 12.0291 6.34571C12.0291 6.52952 12.0647 6.69975 12.1358 6.85642L12.1549 6.89441L10.6852 7.95758C10.5406 8.06009 10.4224 8.04242 10.3307 7.90456L8.60247 5.31986L8.62169 5.30912C8.80864 5.19777 8.95767 5.04843 9.06878 4.86108C9.17989 4.67374 9.23545 4.46518 9.23545 4.23542C9.23545 4.01273 9.17989 3.80682 9.06878 3.61771C8.95767 3.4286 8.80864 3.27837 8.62169 3.16702C8.43474 3.05567 8.22839 3 8.00265 3C7.77337 3 7.56526 3.05567 7.37831 3.16702C7.19136 3.27837 7.04233 3.42771 6.93122 3.61506C6.82011 3.8024 6.76455 4.00919 6.76455 4.23542C6.76455 4.46518 6.82099 4.67374 6.93386 4.86108C7.04674 5.04843 7.19665 5.19777 7.3836 5.30912L7.40058 5.31895L5.66931 7.91516C5.62698 7.97526 5.58025 8.01149 5.5291 8.02386C5.47795 8.03623 5.41182 8.01414 5.33069 7.95758L3.84999 6.88355L3.86423 6.85642C3.93534 6.69975 3.9709 6.52952 3.9709 6.34571C3.9709 6.12301 3.91534 5.91711 3.80423 5.728C3.69312 5.53888 3.54409 5.38865 3.35714 5.27731C3.17019 5.16596 2.96384 5.11029 2.7381 5.11029C2.50882 5.11029 2.30071 5.16596 2.11376 5.27731C1.92681 5.38865 1.77778 5.538 1.66667 5.72534C1.55556 5.91269 1.5 6.11948 1.5 6.34571C1.5 6.57547 1.55644 6.78402 1.66931 6.97137C1.78219 7.15871 1.93122 7.30806 2.1164 7.41941C2.30159 7.53075 2.50882 7.58643 2.7381 7.58643L2.79168 7.58395L3.48413 10H12.5265ZM10.7063 13C11.1261 13 11.4524 12.8975 11.6852 12.6925C11.918 12.4875 12.0838 12.1835 12.1825 11.7805L12.3413 11H3.66402L3.81746 11.7805C3.91623 12.1835 4.08201 12.4875 4.31482 12.6925C4.54762 12.8975 4.87566 13 5.29894 13H10.7063Z" fill="#CFA72E" />
            </svg>
        )
    }
    const getInnerHtml = () => {
        return(
            <div className="pro_dialog_container">
                <div>
                    <div style={{justifyContent : isDesktop ? 'center' : 'left'}} className='flex'>
                        <div style={{textAlign : isDesktop ? 'center' : 'left'}} className="pro_dialog_title">Необходим статус</div>
                        <div style={{margin : '2px 0 0 8px'}}><ProIcon isShow/></div>
                    </div>
                    <div style={{textAlign : isDesktop ? 'center' : 'left'}} className="pro_dialog_text">Для связи с автором объявления необходим статус PRO</div>
                    <div onClick={activate} style={{marginLeft : isDesktop ? 'auto' : '0'}} className="ads_need_pro_btn hover"><div>Получить статус</div> <div className='ads_need_pro_btn_badge'>{crown_bagde()}PRO</div></div>
                </div>
            </div>
        )
    }
    if (isDesktop){
        if (!props.isShow){
            return null
        }
        return(<BaseDesktopDialog setShow={props.setShow} isShow={props.isShow} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} onDismiss={() => props.setShow(false)} open={props.isShow}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
    
}

export default NeedProDialog;
